var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-control-label-vertical",
    { attrs: { label: _vm.coLabel } },
    [
      _vm.attribute.attribute_type.type === "string"
        ? _c("v-textarea", {
            staticClass: "white",
            attrs: {
              counter: _vm.textConfigs.textarea,
              maxlength: _vm.textConfigs.textarea,
              color: "primary",
              solo: "",
              rows: 2,
              "auto-grow": "",
              clearable: _vm.vModel && _vm.vModel.length > 0
            },
            model: {
              value: _vm.vModel,
              callback: function($$v) {
                _vm.vModel = $$v
              },
              expression: "vModel"
            }
          })
        : _vm.attribute.attribute_type.type === "number"
        ? _c("v-text-field", {
            attrs: { counter: 10, maxlength: 10, type: "number", solo: "" },
            model: {
              value: _vm.vModel,
              callback: function($$v) {
                _vm.vModel = $$v
              },
              expression: "vModel"
            }
          })
        : _vm.attribute.attribute_type.type === "boolean"
        ? _c("v-switch", {
            staticClass: "ma-0",
            attrs: { color: "primary" },
            model: {
              value: _vm.vModel,
              callback: function($$v) {
                _vm.vModel = $$v
              },
              expression: "vModel"
            }
          })
        : _vm.attribute.attribute_type.type === "date"
        ? _c(
            "v-menu",
            {
              attrs: {
                "close-on-content-click": false,
                "nudge-right": 40,
                lazy: "",
                transition: "scale-transition",
                "offset-y": "",
                "full-width": "",
                "min-width": "290px"
              },
              model: {
                value: _vm.dateMenu,
                callback: function($$v) {
                  _vm.dateMenu = $$v
                },
                expression: "dateMenu"
              }
            },
            [
              _c(
                "template",
                { slot: "activator" },
                [
                  _c("v-text-field", {
                    attrs: {
                      "prepend-inner-icon": "event",
                      readonly: "",
                      solo: ""
                    },
                    model: {
                      value: _vm.computedDateFormattedMomentjs,
                      callback: function($$v) {
                        _vm.computedDateFormattedMomentjs = $$v
                      },
                      expression: "computedDateFormattedMomentjs"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("v-date-picker", {
                attrs: { locale: "fr-fr", "first-day-of-week": "1" },
                on: {
                  input: function($event) {
                    _vm.dateMenu = false
                  }
                },
                model: {
                  value: _vm.vModel,
                  callback: function($$v) {
                    _vm.vModel = $$v
                  },
                  expression: "vModel"
                }
              })
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c8915e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c8915e0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/attribute-manager/template.html
// module id = null
// module chunks = 